import {EnvService as Parent} from "../../../@bizkeytech";


/**
 * @inheritDoc
 */
class EnvService extends Parent {

    /**
     * The base url of the cms api endpoints of this application.
     */
    static CMSApiEndpointUrl: string = process.env.REACT_APP_CMS_API_ENDPOINT_URL ?? "";

    /**
     * The business token of the application
     */
    static CMSBusinessToken: string = process.env.REACT_APP_CMS_BUSINESS_TOKEN ?? "";

    /**
     * The application token of the application
     */
    static CMSApplicationToken: string = process.env.REACT_APP_CMS_APPLICATION_TOKEN ?? "";

}

export default EnvService;
